<div class="flex items-center ml-4">
  <mat-icon class="text-gray mr-3">search</mat-icon>
  <input [formControl]="value" [placeholder]="'catalog.facet.facet_filter_title' | transloco" class="w-full" matInput/>
  <button (click)="value.setValue('')" class="ml-1" mat-icon-button>
    <mat-icon class="text-gray">close</mat-icon>
  </button>
</div>
